import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { Badge } from '@scramble/ui';
import { Image } from '@/components/Image';
import { Avatar } from '@/components/UI/Avatar';
import { EMPTY_DASH, prettyMoney } from '@scramble/utils';
import { getNameInitials, prettyDate } from '@/helpers/utils';
import s from './index.module.scss';

export const BrandCard = ({ brand }) => {
  const { t } = useTranslation();
  const { openModal, setData } = useModal();

  const openBrandModal = () => {
    setData(brand.slug);
    openModal(MODAL_IDS.brand_detail_modal);
  };

  return (
    <div className={s.wrapper} onClick={openBrandModal}>
      <div className={s.card}>
        <div className={s.card__top}>
          <div
            className={s.brand_image}
            data-status={brand.statuses.join(', ')}
          >
            <Image
              image={brand.promo_image}
              preset="brandCard"
              alt={brand.name}
            />
          </div>
          <div className={s.brand_founders}>
            {brand.founders.map((founder, index) => (
              <div
                key={founder.id}
                className={s.brand_founder}
                style={{ zIndex: index }}
              >
                <Avatar
                  size={56}
                  image={founder.avatar}
                  alt={founder.full_name}
                  nameInitials={getNameInitials(
                    founder.full_name?.split(' ')[0],
                    founder.full_name?.split(' ')[1],
                  )}
                />
              </div>
            ))}
          </div>
        </div>
        <div className={s.card__bottom}>
          <div>
            <div className="f-body-md f-500">{brand.name}</div>
            <div className={s.brand_info}>
              <div>
                {t('investing:brand_card.started', {
                  year:
                    brand.foundation_year || brand.foundation_date
                      ? prettyDate(brand.foundation_date, 'YYYY')
                      : EMPTY_DASH,
                })}
              </div>
              <div>
                {t('investing:brand_card.goal', {
                  amount: prettyMoney(brand.active_limit),
                })}
              </div>
            </div>
          </div>
          <div className={s.brand_badges}>
            <Badge
              label={brand.promo_theme}
              size="medium"
              type="neutral"
              appearance="tonal"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
